import React from 'react';
import PropTypes from 'prop-types';
import {
  ContainerListStyled,
  ContentFooterStyled,
  DetailStyled,
  PriceContainerStyled,
  PriceTextStyled,
  PriceWarningStyled,
} from './styles/PlanListStyled';

import { Numbers } from '../../../helpers';

import Button from '../../General/Button';

import { ReactComponent as PlanIcon } from '../../../images/plan-recurrente/planIcon.svg';
import { ReactComponent as PlanIconBackground } from '../../../images/plan-recurrente/planIconBackground.svg';

const PlanDetail = ({ data, buyCallback, showButton }) => {
  const buyHandler = () => {
    buyCallback(data);
  };

  return (
    <ContainerListStyled>
      <DetailStyled>
        <picture>
          <PlanIcon />
        </picture>
        <hgroup>
          <h4>{data.name}</h4>
        </hgroup>
      </DetailStyled>
      <p>{data.description}</p>
      <ContentFooterStyled>
        <PriceContainerStyled>
          <PriceTextStyled>
            {`$${Numbers.addThousandSeparators(data.price)}`}
          </PriceTextStyled>
          <PriceWarningStyled>CARGO FIJO MENSUAL</PriceWarningStyled>
        </PriceContainerStyled>
        {showButton && (
          <Button click={buyHandler} color="bubbleGum" maxWidth="153px">
            Comprar
          </Button>
        )}
      </ContentFooterStyled>
      <figure>
        <PlanIconBackground />
      </figure>
    </ContainerListStyled>
  );
};

PlanDetail.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
  buyCallback: PropTypes.func,
  showButton: PropTypes.bool,
};

PlanDetail.defaultProps = {
  buyCallback: null,
  showButton: true,
};

export default PlanDetail;
